<template lang="pug">
.button-upload
  button-icon-circle.button-upload__button(type='upload', @click='onClickButton')
    slot(name='iconLabel')
  input.button-upload__uploder(ref='uploder', type='file', @change='onFileSelect')
</template>

<script lang="ts">
import { Component, Vue, Prop, Ref } from 'vue-property-decorator'
import ButtonIconCircle from '@/components/molecules/manager/ButtonIconCircle.vue'

/**
 * ファイルを選択してアップロードするボタン
 */
@Component({
  components: {
    ButtonIconCircle,
  },
})
export default class ButtonUpload extends Vue {
  // アップロードイベント
  @Prop()
  uploadEvent!: Function

  // inputのref
  @Ref()
  uploder!: HTMLInputElement

  // ボタンクリック時にinputもクリック
  private onClickButton() {
    // 同じファイルを連続して選択してもchangeイベントが発火するよう値を初期化
    this.uploder.value = ''
    this.uploder.click()
  }

  // ファイル選択時にファイル情報を渡してアップロードイベントを実行
  private onFileSelect(e: Event) {
    const target = e.target as HTMLInputElement
    const file = (target.files as FileList)[0]

    this.uploadEvent(file)
  }
}
</script>

<style lang="stylus" scoped>
.button-upload
  &__button
    width 100%
    height 100%
  &__uploder
    display none
</style>
